import { render, staticRenderFns } from "./clientepuerta.vue?vue&type=template&id=4f82e9e9&"
import script from "./clientepuerta.vue?vue&type=script&lang=js&"
export * from "./clientepuerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports